module.exports = __webpack_public_path__ + "img/logo_venx_b.297b41e6.png";